/* Contact (sections/st-contact.liquid). With script: only the chosen reason's note shows; a reason
   that links to another page hides the form; a reason that asks for the order number shows that
   field and makes it required; the form is checked before sending, with a summary linked to each
   field and the error beside it, tied to the field only while it shows. The browser's own checks
   stay on until this runs (novalidate is added here, not in the markup). */
(() => {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(form) {
    if (form.dataset.stReady) return;
    form.dataset.stReady = 'true';
    const sent = form.querySelector('[data-st-sent]');
    if (sent) {
      setTimeout(() => sent.focus(), 0);
      return;
    }
    form.querySelector('[data-st-server-errors]')?.focus();
    form.noValidate = true;

    const radios = [...form.querySelectorAll('[data-st-route]')];
    const notes = [...form.querySelectorAll('[data-st-route-note]')];
    const fieldsBox = form.querySelector('[data-st-fields]');
    const send = form.querySelector('[data-st-send]');
    const orderBox = form.querySelector('[data-st-order-field]');
    const order = orderBox?.querySelector('input');
    const orderOpt = form.querySelector('[data-st-order-opt]');
    const summary = form.querySelector('[data-st-summary]');

    const current = () => radios.find((r) => r.checked);
    const noteFor = (radio) => notes.find((n) => n.dataset.stRouteNote === radio?.dataset.stRoute);

    const route = () => {
      const note = noteFor(current());
      notes.forEach((n) => (n.hidden = n !== note));
      const out = !!note?.hasAttribute('data-st-links-out');
      fieldsBox.hidden = out;
      send.hidden = out;
      const asks = !!note?.hasAttribute('data-st-asks-order');
      if (orderBox) orderBox.hidden = !asks;
      if (order) {
        order.required = asks;
        order.toggleAttribute('aria-required', asks);
        if (asks) order.setAttribute('aria-required', 'true');
      }
      if (orderOpt) orderOpt.hidden = asks;
      if (summary) summary.hidden = true;
    };
    radios.forEach((r) => r.addEventListener('change', route));
    // A link can open a reason: /pages/contact?topic=metal (the reason's "Link name" setting).
    const topic = new URLSearchParams(window.location.search).get('topic');
    const pick = topic && radios.find((r) => r.dataset.stTopic === topic);
    if (pick) pick.checked = true;

    const fields = () => [...form.querySelectorAll('[data-st-field]')].filter((f) => !f.closest('[hidden]'));
    const bad = (input) => {
      const value = input.value.trim();
      return (input.required && !value) || (input.type === 'email' && !!value && !EMAIL.test(value));
    };
    const mark = (input, isBad) => {
      const error = document.getElementById(input.dataset.stErr);
      const ids = [input.dataset.stHint, isBad ? input.dataset.stErr : ''].filter(Boolean).join(' ');
      if (ids) input.setAttribute('aria-describedby', ids);
      else input.removeAttribute('aria-describedby');
      if (isBad) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      if (error) error.hidden = !isBad;
    };
    form.querySelectorAll('[data-st-field]').forEach((input) =>
      ['input', 'blur'].forEach((type) =>
        input.addEventListener(type, () => {
          if (!input.hasAttribute('aria-invalid') || bad(input)) return;
          mark(input, false);
          summary?.querySelector(`a[href="#${CSS.escape(input.id)}"]`)?.closest('li')?.remove();
          if (summary && !summary.querySelector('li')) summary.hidden = true;
        })
      )
    );

    const check = (event) => {
      const problems = fields().filter((input) => {
        const isBad = bad(input);
        mark(input, isBad);
        return isBad;
      });
      if (!problems.length) {
        if (summary) summary.hidden = true;
        return;
      }
      event.preventDefault();
      if (!summary) return;
      summary.querySelector('[data-st-summary-list]').replaceChildren(
        ...problems.map((input) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${input.id}`;
          a.textContent = input.dataset.stLabel || input.id;
          a.addEventListener('click', (e) => {
            e.preventDefault();
            input.focus();
          });
          li.append(a);
          return li;
        })
      );
      summary.hidden = false;
      summary.focus();
    };
    // On the button's click as well as submit: Shopify's bot protection handles submit and can
    // take focus into its own frame (found on the quote quiz).
    form.querySelector('[type="submit"]')?.addEventListener('click', check);
    form.addEventListener('submit', check);
    route();
  }

  const run = () => document.querySelectorAll('form.st-contact__form').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
